module.exports = __webpack_public_path__ + "dist/img/clean.58b3842e.jpg";